import React from "react"
import { Link } from "gatsby"
import Image from '../components/image';
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Tooltip, Avatar, Grid, Typography } from "@material-ui/core";
import { Assistant, Loyalty } from "@material-ui/icons";
import QuizWrapper from "../components/Quiz/QuizWrapper";
import MoreInfo from '../components/moreInfo';

import chars from '../data/characters.json';
import quizData from '../data/quiz.json';
import '../styles/quiz.scss';

const description = `Which stranger things character could you be? Take the personality quiz/test and find your associated stranger things character with a large variety of characters. It's not another boring quiz!`;
const keywords = [
  "stranger things stuffs",
  "stranger things",
  "nerdy quiz",
  "nerdy test",
  "character quiz",
  "ST",
  "Eleven",
  "Mike",
  "Will",
  "Dustin",
  "Lucas",
  "Mad Max",
  "Dr Brenner",
  "Nancy",
  "Jonathan",
  "Suzie",
  "Erica",
  "Billy",
  "Dr Owen",
  "Murray",
  "Joyce",
  "Bob Newby",
  "Jim Hopper",
  "Karen",
  "Mayor Larry",
  "Alexei",
  "Robin",
  "Steve",
  "Scott",
  "Ted"
]

const mi = {
  why: `<ul>
    <li>To have some fun</li>
    <li>To know which character we are matched the most</li>
  </ul>`,
  method: `<ul>
    <li>Static scoring</li>
    <li>Machine learning approach (Neural Network Regression)</li>
  </ul>
  <div>
  <iframe width="100%" height="300" src="https://www.youtube-nocookie.com/embed/cGmo-CpwGoQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
  `,
  accuracy: `<div>
    Not sure. no way to measure this type of issue because the scoring approach could be different from person to person
  </div>`,
  version: `<div>v0.1.1</div>`,
}

const QuizMainPage = () => {
  return (
    <Layout navNumber={1}>
      <SEO
        title="Find Which Character You Are In Stranger Things TV Show - Quiz"
        description={description}
        keywords={keywords.join(",")}
      />
      <div id="Quiz">
        <div className="head">
          <Image className="el" name="el" />
          <h1>Check out who do you look like the most in personality By taking this stranger-things-<b>quiz</b></h1>
        </div>
        <p>
          "<a href="https://www.netflix.com/nl-en/title/80057281" target="_blank" rel="noopener noreferrer">Stranger Things</a>"
          is one of the best trending tv shows nowadays which is made by the Netflix original series.
        </p>
        <p>The events of stranger things take place circa 1983 in <b>Hawkins</b>, Indiana -a fictional town- and begins with vanishing of Will Byers, one of the lovely characters.</p>
        <p>I highly suggest you to watch this series and then make sure you do this little nerdy quiz to find out which character you do look like the most.</p>
        <div>
          <h2>You'll be matched with one of these characters:</h2>
          <Grid container component="ul" spacing={2}>
            {
              chars.map((char) => (
                <Grid key={char.row} item component="li" xs={4} sm={3} md={2} lg={1} xl={1}>
                  <Tooltip title={char.name} arrow placement="top">
                    <Avatar style={{ width: 100, height: 100, boxShadow: "0 0 6px #6b6b6b" }}>
                      <Image name={char.avatar} style={{ width: "100%", height: "100%" }} />
                    </Avatar>
                  </Tooltip>
                </Grid>
              ))
            }
          </Grid>
          <div><b>Your Personality is similar to</b> ... !</div>
          <div><b>Guess Who? Just do the test to make sure!</b></div>
        </div>
        <br />
        <h3 className="ai-ml"><Assistant /> Powered By Artificial Intelligence & Machine Learning</h3>
        <Typography variant="subtitle1">There are <b>011</b> questions to pay tribute to ELEVEN <Loyalty color="secondary" /></Typography>
        <Typography variant="subtitle1">Let's begin the QUIZ, Shall we?</Typography>
        <br />
        <div>
          <QuizWrapper data={quizData} />
        </div>
        <div>
          <MoreInfo
            why={mi.why}
            method={mi.method}
            accuracy={mi.accuracy}
            version={mi.version}
          />
        </div>
        <Link to="/">Go back to the homepage</Link>
      </div>
    </Layout>
  );
}

export default QuizMainPage
